import type { FC, ReactElement } from "react";

import { usePageContext } from "@ryde/redux";
import { isEntityWithoutBulkActions, useIsMobile } from "@ryde/shared";

import { BulkGridSelectionControl, EditGridColumnButton } from "../elements";
import { PanelTopStatCommon } from "../panels-stat";
import { PanelTopStyled } from "./panel-top.styled";

interface IPanelTopProps {
  StartAddition?: ReactElement;
  PanelTopStatCommonReplacement?: ReactElement;
}

export const PanelTop: FC<IPanelTopProps> = ({
  StartAddition,
  PanelTopStatCommonReplacement,
}) => {
  const { entity } = usePageContext();
  const { isMobile } = useIsMobile();
  const showBulkGridSelection = !isEntityWithoutBulkActions(entity);

  if (isMobile) {
    return null;
  }

  return (
    <PanelTopStyled>
      {showBulkGridSelection && <BulkGridSelectionControl />}
      {Boolean(StartAddition) && StartAddition}
      <div className="panelTopRight">
        {Boolean(PanelTopStatCommonReplacement) &&
          PanelTopStatCommonReplacement}
        {!PanelTopStatCommonReplacement && <PanelTopStatCommon />}
        <EditGridColumnButton />
      </div>
    </PanelTopStyled>
  );
};
